import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles/index";
import { actNotificationRemove } from "actions/notificationActions";
import icwStyles from "assets/jss/icwStyle";
import MessageBar from "./MessageBar";

const Notifications = ({ classes, notifications, onRemoveNotification }) =>
    notifications.length > 0 && (
        <ul className={classes.noMargin}>
            {notifications.map(notification => {
                const { key } = notification;
                return <MessageBar {...notification} onDismiss={() => onRemoveNotification(key)} />;
            })}
        </ul>
    );

Notifications.propTypes = {
    classes: PropTypes.object.isRequired,
    notifications: PropTypes.object.isRequired,
    onRemoveNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    notifications: state.notifications,
});

const mapDispatchToProps = dispatch => ({
    onRemoveNotification: key => dispatch(actNotificationRemove(key)),
});

export default withStyles(icwStyles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Notifications)
);
